import { useState } from 'react';
import DsarList from './DsarList';
import DsarForm from './DsarForm';
import DsarDetail from './DsarDetail';
import DsarModelos from './DsarModelos';

export default function Dsar({ token, usuario, filtroInicial }) {
  const [tela, setTela] = useState('list');
  const [solicitacaoId, setSolicitacaoId] = useState(null);

  if (tela === 'nova') {
    return <DsarForm token={token} onVoltar={() => setTela('list')} />;
  }
  if (tela === 'ver') {
    return (
      <DsarDetail
        token={token}
        solicitacaoId={solicitacaoId}
        onVoltar={() => setTela('list')}
      />
    );
  }
  if (tela === 'modelos') {
    return (
      <div>
        <button onClick={() => setTela('list')} className="link-back mb-12">← Solicitações</button>
        <DsarModelos token={token} usuario={usuario} />
      </div>
    );
  }

  return (
    <div>
      <DsarList
        token={token}
        filtroInicial={filtroInicial}
        onModelos={() => setTela('modelos')}
        onNova={() => setTela('nova')}
        onVer={(id) => { setSolicitacaoId(id); setTela('ver'); }}
      />
    </div>
  );
}
